import React, { useRef, useState, useEffect } from "react";
import { Eraser } from "lucide-react";

export default function SignaturePad({ onChange, testid = "signature-pad" }) {
  const canvasRef = useRef(null);
  const drawing = useRef(false);
  const hasInkRef = useRef(false);
  const [hasInk, setHasInk] = useState(false);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ratio = window.devicePixelRatio || 1;
    const rect = canvas.getBoundingClientRect();
    canvas.width = rect.width * ratio;
    canvas.height = rect.height * ratio;
    const ctx = canvas.getContext("2d");
    ctx.scale(ratio, ratio);
    ctx.lineWidth = 2.5;
    ctx.lineCap = "round";
    ctx.lineJoin = "round";
    ctx.strokeStyle = "#0a1224";
  }, []);

  const pos = (e) => {
    const rect = canvasRef.current.getBoundingClientRect();
    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    const clientY = e.touches ? e.touches[0].clientY : e.clientY;
    return { x: clientX - rect.left, y: clientY - rect.top };
  };

  const start = (e) => {
    e.preventDefault();
    drawing.current = true;
    const ctx = canvasRef.current.getContext("2d");
    const { x, y } = pos(e);
    ctx.beginPath();
    ctx.moveTo(x, y);
  };
  const move = (e) => {
    if (!drawing.current) return;
    e.preventDefault();
    const ctx = canvasRef.current.getContext("2d");
    const { x, y } = pos(e);
    ctx.lineTo(x, y);
    ctx.stroke();
    hasInkRef.current = true;
    setHasInk(true);
  };
  const end = () => {
    if (!drawing.current) return;
    drawing.current = false;
    if (hasInkRef.current) onChange?.(canvasRef.current.toDataURL("image/png"));
  };

  const clear = () => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    hasInkRef.current = false;
    setHasInk(false);
    onChange?.("");
  };

  return (
    <div>
      <div className="relative border-2 border-wcc-ink/20 bg-white">
        <canvas
          ref={canvasRef}
          data-testid={testid}
          className="w-full h-40 touch-none cursor-crosshair block"
          onMouseDown={start} onMouseMove={move} onMouseUp={end} onMouseLeave={end}
          onTouchStart={start} onTouchMove={move} onTouchEnd={end}
        />
        {!hasInk && (
          <span className="absolute inset-0 grid place-items-center pointer-events-none mono text-xs uppercase tracking-widest text-wcc-ink/30">
            Sign here
          </span>
        )}
      </div>
      <button type="button" onClick={clear} data-testid={`${testid}-clear`}
        className="mt-2 inline-flex items-center gap-1.5 mono text-[10px] uppercase tracking-widest text-wcc-gray hover:text-wcc-red transition-colors">
        <Eraser className="w-3.5 h-3.5" /> Clear signature
      </button>
    </div>
  );
}
